const DateUtils = {
  date2StrYMD: function(date) {
    var fmt = 'yyyy-MM-dd';
    var o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp('(' + k + ')').test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        );
    return fmt;
  },
  date2StrYM: function(date) {
    var fmt = 'yyyy-MM';
    var o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp('(' + k + ')').test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        );
    return fmt;
  },
};

/**
 * 日期格式化函数
 * @param {Date|string|number} date - 要格式化的日期
 * @param {string} format - 格式化模板字符串
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, format = 'yyyy-MM-dd HH:mm:ss') => {
  // 处理输入参数
  if (!date) return '';
  let d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';

  const formatObj = {
    y: d.getFullYear(),
    M: d.getMonth() + 1,
    d: d.getDate(),
    H: d.getHours(),
    h: d.getHours() % 12 || 12,
    m: d.getMinutes(),
    s: d.getSeconds(),
    q: Math.floor((d.getMonth() + 3) / 3),
    S: d.getMilliseconds(),
    w: d.getDay(),
  };

  const timeStr = format.replace(/([yMdHhmsSqwaA])+/g, (all, t) => {
    let str = formatObj[t]?.toString() || '';

    if (t === 'y') {
      // 年份处理
      return str.slice(-all.length);
    } else if (['M', 'd', 'H', 'h', 'm', 's'].includes(t)) {
      // 需要补零的数字
      return all.length > 1 ? str.padStart(2, '0') : str;
    } else if (t === 'S') {
      // 毫秒处理
      return str.padStart(3, '0').slice(0, all.length);
    } else if (t === 'a') {
      // am/pm
      return formatObj.H < 12 ? 'am' : 'pm';
    } else if (t === 'A') {
      // AM/PM
      return formatObj.H < 12 ? 'AM' : 'PM';
    }
    return str;
  });
  return timeStr;
};

export default DateUtils;
